import React from 'react';
import courseImage from '../assets/prepcourse.jpg'; // Replace with actual image
import courseImage2 from '../assets/pluscourse.jpeg';
import courseImage3 from '../assets/premiumcourse.jpeg';
import { useNavigate } from 'react-router-dom'; // Make sure to import useNavigate

const CourseOffering = () => {
    const navigate = useNavigate(); // Initialize the navigate function

    return (
        <section
            id='courses'
            style={{
                padding: '20px',
                fontFamily: 'Arial, sans-serif',
                textAlign: 'center',
            }}
        >
            <h2
                style={{
                    fontSize: '1.8rem',
                    marginBottom: '20px',
                    color: '#042B4C',
                }}
            >
                Enroll in Our Courses
            </h2>

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '20px',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        maxWidth: '300px',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        textAlign: 'left',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <img
                        src={courseImage}
                        alt="IMAT Preparation"
                        style={{
                            width: '100%',
                            height: '200px',
                            objectFit: 'cover',
                        }}
                    />
                    <div style={{ padding: '10px' }}>
                        <h3
                            style={{
                                fontSize: '1.2rem',
                                margin: '10px 0',
                                color: '#444',
                            }}
                        >
                            IMAT Meditalia Prep Course
                            (€129) – 3 Months
                        </h3>
                        <p style={{ fontSize: '0.9rem', color: '#666' }}>
                            Get access to premium study materials and expert guidance to ace your IMAT exams.
                        </p>
                        <button
                            style={{
                                marginTop: '10px',
                                padding: '10px 15px',
                                fontSize: '0.9rem',
                                backgroundColor: '#042B4C',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                            onClick={() => navigate('/course-detail')}
                        >
                            Read More
                        </button>
                    </div>
                </div>

                <div
                    style={{
                        width: '100%',
                        maxWidth: '300px',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        textAlign: 'left',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <img
                        src={courseImage2}
                        alt="IMAT Preparation"
                        style={{
                            width: '100%',
                            height: '200px',
                            objectFit: 'cover',
                        }}
                    />
                    <div style={{ padding: '10px' }}>
                        <h3
                            style={{
                                fontSize: '1.2rem',
                                margin: '10px 0',
                                color: '#444',
                            }}
                        >
                            IMAT Meditalia+ Plus Course
                            (€310) – 3 Months
                        </h3>
                        <p style={{ fontSize: '0.9rem', color: '#666' }}>
                            Personalized coaching and test simulations to boost your confidence.
                        </p>
                        <button
                            style={{
                                marginTop: '10px',
                                padding: '10px 15px',
                                fontSize: '0.9rem',
                                backgroundColor: '#042B4C',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                            onClick={() => navigate('/imat-meditalia-plus')}
                        >
                            Read More
                        </button>
                    </div>
                </div>

                <div
                    style={{
                        width: '100%',
                        maxWidth: '300px',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        textAlign: 'left',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <img
                        src={courseImage3}
                        alt="IMAT Preparation"
                        style={{
                            width: '100%',
                            height: '200px',
                            objectFit: 'cover',
                        }}
                    />
                    <div style={{ padding: '10px' }}>
                        <h3
                            style={{
                                fontSize: '1.2rem',
                                margin: '10px 0',
                                color: '#444',
                            }}
                        >
                            IMAT Meditalia Premium Course
                            (€750) – 6 Months
                        </h3>
                        <p style={{ fontSize: '0.9rem', color: '#666' }}>
                            Structured learning path with interactive classes and doubt-clearing sessions.
                        </p>
                        <button
                            style={{
                                marginTop: '10px',
                                padding: '10px 15px',
                                fontSize: '0.9rem',
                                backgroundColor: '#042B4C',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                            onClick={() => navigate('/course-detail2')}
                        >
                            Read More
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CourseOffering;










// import React from 'react';
// import './CourseOffering.css';
// import courseImage from '../assets/Doc2.jpeg'; // Replace with actual image
// import courseImage2 from '../assets/Doctor.jpeg';
// import courseImage3 from '../assets/Doctor1.jpeg';
// import { useNavigate } from 'react-router-dom'; // Make sure to import useNavigate

// const CourseOffering = () => {
//     const navigate = useNavigate(); // Initialize the navigate function

//     return (
//         <section id='courses' className="course-offering">
//             <h2 className="course-heading">Unlock Your Potential with Our <br /> Comprehensive Course Offering</h2>
            
//             <div className="course-cards">
//                 <div className="course-card">
//                     <img src={courseImage} alt="IMAT Preparation" />
//                     <h3>IMAT Preparation Courses (Premium)</h3>
//                     <p>Get access to premium study materials and expert guidance to ace your IMAT exams.</p>
//                     <button className="read-more-btn" onClick={() => navigate('/course-detail')}>Read More</button>
//                 </div>
                
//                 <div className="course-card">
//                     <img src={courseImage2} alt="IMAT Preparation" />
//                     <h3>IMAT Preparation Courses (Premium)</h3>
//                     <p>Personalized coaching and test simulations to boost your confidence.</p>
//                     <button className="read-more-btn" onClick={() => navigate('/IMATMeditalia+')}>Read More</button>
//                 </div>

//                 <div className="course-card">
//                     <img src={courseImage3} alt="IMAT Preparation" />
//                     <h3>IMAT Preparation Courses (Premium)</h3>
//                     <p>Structured learning path with interactive classes and doubt-clearing sessions.</p>
//                     <button className="read-more-btn" onClick={() => navigate('/course-detail2')}>Read More</button>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default CourseOffering;
